const maskEmail = (email) => {
  if (!email || typeof email !== 'string') return '';

  const [localPart, domain] = email.split('@');
  if (localPart.length < 4) return email;

  const firstTwo = localPart.slice(0, 2);
  const lastTwo = localPart.slice(-2);
  const maskedPart = '*'.repeat(localPart.length - 4);
  return `${firstTwo}${maskedPart}${lastTwo}@${domain}`;
};

export default maskEmail;
